<div *ngIf="informantForm">
    <div *ngIf="questionIndex === 0">
        <div [formGroup]="informantForm" class="mt-1">
            <div class="form-group row">
                <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                <div class="col-10">
                    <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
                        ngDefaultControl (change)="setQuestionInformant(informantForm.value.question)">
                </div>
            </div>

            <div *ngFor="let c of informantFormArray.controls; let i = index" formArrayName="choices">
                <div [formGroupName]="i" class="form-group row">
                    <label class="col-1 col-form-label">C{{i+1}}<lifedi-require></lifedi-require></label>
                    <input class="form-control col-10" formControlName="choice_detail" type="text"
                        (change)="setChoiceInformant(c.value.choice_detail, i)" (change)="copyArr()">
                    <button mat-mini-fab class="img col-1" (click)="deleteChoice(informantFormArray, i)"
                        [style.backgroundImage]="'url(\' ../../../../assets/remove.png\')'">
                    </button>
                </div>
            </div>

            <button mat-mini-fab class="img col-1" (click)="addChoice(informantFormArray)"
                [style.backgroundImage]="'url(\' ../../../../assets/add.png\')'">
            </button>
        </div>
    </div>
    <div *ngIf="questionIndex !== 0">
        <div class="mt-1">
            <div class="form-group row">
                <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                <div class="col-10">
                    <input type="text" class="form-control" id="question" (change)="copyArr()"
                        [(ngModel)]="informantArray[questionIndex - 1].question" autocomplete="off" ngDefaultControl>
                </div>
            </div>

            <div *ngFor="let c of informantArray[questionIndex - 1].choices; let i = index">
                <div class="form-group row">
                    <label class="col-1 col-form-label">C{{i+1}}<lifedi-require></lifedi-require></label>
                    <input class="form-control col-10" (change)="copyArr()" [(ngModel)]="c.choice_detail" type="text">
                </div>
            </div>
        </div>
    </div>
</div>